import type { CityConfig } from "../city-template/types";

export const concordNhConfig: CityConfig = {
  city: "Concord",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "concord-nh",
  route: "/cities/concord-nh",
  title: "Emergency Passport Concord, NH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Concord, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Merrimack County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Concord, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Concord and central New Hampshire travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Concord%20New%20Hampshire%20state%20capital%20view%20with%20the%20golden%20dome%20of%20the%20New%20Hampshire%20State%20House%2C%20historic%20downtown%20main%20street%20with%20charming%20New%20England%20architecture%2C%20warm%20autumn%20light%20with%20red%20and%20orange%20maple%20trees%2C%20clean%20and%20inviting%20urban%20scene%2C%20professional%20architectural%20photography%2C%20wide%20panoramic%20view%2C%20no%20visible%20text%20or%20people%2C%20soft%20golden%20sky%20and%20warm%20earth%20tones%2C%20photorealistic%20cityscape&width=1800&height=700&seq=concord-nh-hero-001&orientation=landscape",
  heroImageAlt: "Concord New Hampshire state capital with the golden dome of the New Hampshire State House and historic downtown",
  geoPosition: "43.2081;-71.5376",
  geoPlacename: "Concord, New Hampshire",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St Suite 247, Boston MA 02222",
    distance: "Approximately 75 miles, 1.25 hours via I-93",
  },
  nearbyCitiesZips: [
    { name: "Concord", zips: "03301–03305" },
    { name: "Bow", zips: "03304" },
    { name: "Pembroke", zips: "03275" },
    { name: "Loudon", zips: "03307" },
    { name: "Hopkinton", zips: "03229" },
    { name: "Chichester", zips: "03258" },
    { name: "Epsom", zips: "03234" },
    { name: "Boscawen", zips: "03303" },
    { name: "Penacook", zips: "03303" },
    { name: "Suncook", zips: "03275" },
    { name: "Weare", zips: "03281" },
    { name: "Goffstown", zips: "03045" },
    { name: "Dunbarton", zips: "03046" },
    { name: "Henniker", zips: "03242" },
    { name: "Warner", zips: "03278" },
    { name: "Contoocook", zips: "03229" },
    { name: "Canterbury", zips: "03224" },
    { name: "Franklin", zips: "03235" },
    { name: "Tilton", zips: "03276" },
    { name: "Northfield", zips: "03276" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent central New Hampshire departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Manchester", route: "/cities/manchester" },
    { name: "Nashua", route: "/cities/nashua" },
    { name: "Portsmouth", route: "/portsmouth" },
    { name: "Keene", route: "/keene" },
    { name: "Dover", route: "/dover" },
    { name: "Rochester", route: "/rochester" },
    { name: "Laconia", route: "/laconia" },
    { name: "Lebanon", route: "/lebanon" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Concord remotely via secure courier. We do not have a walk-in office in Concord — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for central New Hampshire travelers.",
  fpcOfficeAddress: "1 New Hampshire Ave, Portsmouth, NH 03801",
  fpcOfficeDistance: "Serving all of Merrimack and Belknap Counties",
  serviceAreaIntro: "From downtown Concord's State House Plaza to the Heights neighborhood, from the West Concord area to the Suncook Valley — Fast Passport Center serves the entire Concord community. We regularly help travelers from Bow, Pembroke, Loudon, and Hopkinton get their passports fast.",
  nearbyCitiesIntro: "We serve all Concord neighborhoods and nearby central New Hampshire cities including Bow, Pembroke, Loudon, Hopkinton, Chichester, Epsom, Boscawen, Weare, Goffstown, Dunbarton, Henniker, Warner, and Franklin. If you are in the greater Concord area, we have you covered.",
  howItWorksIntro: "Most Concord travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency.",
  mistakesIntro: "With Concord Municipal Airport (CON) and easy access to Manchester-Boston Regional (MHT), central New Hampshire travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Concord and central New Hampshire travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Concord? Here are the most common ones we hear from central New Hampshire travelers.",
  processingIntro: "Concord travelers — state government officials with international diplomatic obligations, NHTI and UNH Law students heading abroad, healthcare professionals serving global health missions, and families planning overseas vacations — have several options for getting a passport fast. Here is how they compare, and why most Merrimack County residents choose a U.S. Department of State registered passport courier for reliable, professional processing that does not require a 90-minute drive to Boston.",
  localAreaIntro: [
    "Concord, New Hampshire is more than the state capital — it is the administrative nerve center of the Granite State. The New Hampshire State House, with its iconic golden dome, houses the Governor's office, the General Court, and dozens of state agencies whose employees travel internationally for trade missions, diplomatic conferences, and intergovernmental meetings. When a Department of Business and Economic Affairs delegation secures a last-minute invitation to an international trade summit in Germany or Japan, the passport readiness of every team member becomes an urgent operational question. Standard processing timelines do not serve this audience, and the Boston Passport Agency — 90 minutes south on a good day — requires appointments that may not align with travel dates.",
    "The legal and academic communities add their own urgency. The University of New Hampshire Franklin Pierce School of Law, located in Concord, attracts students and faculty from across the country and around the world. International moot court competitions, legal research fellowships abroad, and semester-exchange programs all require valid passports with sufficient remaining validity — often six months or more beyond the travel date. Law students operating on academic calendars with inflexible deadlines cannot afford to wait 6–13 weeks for standard processing. When a UNH Law student secures a coveted summer internship at an international tribunal in The Hague, they need a passport solution that matches the prestige and timeline of the opportunity.",
    "NHTI — Concord's Community College serves as another source of international travel demand. With growing study-abroad partnerships in Ireland, Costa Rica, and Spain, NHTI students face passport requirements that many encounter for the first time. First-time applicants must appear in person at an acceptance facility, complete Form DS-11, and provide citizenship evidence — a multi-step process that can take weeks if not managed carefully. Fast Passport Center guides these first-time applicants through every step, from finding the nearest acceptance clerk (the Concord Post Office on Loudon Road is the most popular) to reviewing documents before courier submission.",
    "Concord's central location makes it a natural hub for the surrounding communities of Bow, Pembroke, Loudon, Hopkinton, and beyond. Healthcare workers at Concord Hospital who participate in medical missions to Central America, families in the Suncook Valley planning heritage trips to Scotland, and retirees in the Lakes Region booking European river cruises all funnel through Concord for services. Fast Passport Center's overnight shipping model means these travelers never need to leave their community — they complete everything online and ship documents from any UPS location in Merrimack County. No Boston traffic. No agency appointment anxiety. Just predictable, professional passport processing."
  ],
  statePageRoute: "/new-hampshire",
  statePageName: "New Hampshire",
  dmvWebsite: "https://www.nh.gov/safety/divisions/dmv",
  dmvLabel: "New Hampshire DMV — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "New Hampshire Vital Records (Birth, Death, Marriage)", href: "https://www.sos.nh.gov/records-and-vital-records" },
    { label: "Merrimack County Vital Records", href: "https://www.merrimackcounty.net/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Concord international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Patricia W.",
      location: "Concord, NH",
      rating: 5,
      text: "My business trip to Ottawa was in 3 days and my passport was expired. Fast Passport Center got me a new one in 36 hours. Absolutely saved my trip.",
      service: "Emergency Passport",
    },
    {
      name: "Thomas G.",
      location: "Bow, NH",
      rating: 5,
      text: "Needed to renew for a family vacation to Ireland. The process was smooth, they reviewed my documents, and I had my passport in 4 days. Highly recommend.",
      service: "Passport Renewal",
    },
    {
      name: "Michelle R.",
      location: "Pembroke, NH",
      rating: 5,
      text: "Lost my passport the week before my trip to England. They walked me through the DS-64 process and got me a replacement in 2 days. Incredible service.",
      service: "Lost Passport",
    },
    {
      name: "Brian K.",
      location: "Loudon, NH",
      rating: 5,
      text: "As a frequent international traveler from central New Hampshire, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional and reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "concord-nh-1",
      name: "Concord Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18 Loews Dr",
      city: "Concord",
      state: "NH",
      zip: "03301",
      phone: "(603) 224-0631",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.5 miles from downtown Concord",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Concord. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "concord-nh-2",
      name: "Bow Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "546 Bow Center Rd",
      city: "Bow",
      state: "NH",
      zip: "03304",
      phone: "(603) 224-4854",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.7 miles from downtown Bow",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Bow residents. Limited hours — book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "concord-nh-3",
      name: "Pembroke Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6 S Pembroke Rd",
      city: "Pembroke",
      state: "NH",
      zip: "03275",
      phone: "(603) 485-9631",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.5 miles from downtown Pembroke",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Suncook Valley residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "concord-nh-4",
      name: "Loudon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "433 Clough Hill Rd",
      city: "Loudon",
      state: "NH",
      zip: "03307",
      phone: "(603) 798-5321",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.8 miles from downtown Loudon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for northern Merrimack County residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "concord-nh-5",
      name: "Hopkinton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "864 Hopkinton Rd",
      city: "Hopkinton",
      state: "NH",
      zip: "03229",
      phone: "(603) 746-4731",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.6 miles from downtown Hopkinton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves western Merrimack County. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "concord-nh-6",
      name: "Concord City Clerk",
      type: "City Clerk Passport Acceptance",
      address: "41 Green St",
      city: "Concord",
      state: "NH",
      zip: "03301",
      phone: "(603) 225-8500",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from City Hall",
      website: "https://www.concordnh.gov/",
      websiteLabel: "Concord City Clerk",
      notes: "Major municipal facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 75 miles to Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Weekend Availability", agency: "No — business hours only", fpc: "Yes — we work weekends for urgent cases" },
    { feature: "Photo Review", agency: "No — your problem if rejected", fpc: "Yes — pre-submission verification" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Concord photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Merrimack County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Concord applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Concord families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Concord travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Concord." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Concord address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Concord before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Concord for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most central New Hampshire travelers." },
    { q: "How fast can I renew my passport in Concord?", a: "Fast Passport Center offers fast passport renewal in Concord in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Concord in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Concord?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Concord residents." },
    { q: "Can I expedite a child passport in Concord?", a: "Yes. Fast Passport Center expedites child passports in Concord for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Concord with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Concord?", a: "With Fast Passport Center's emergency courier service, Concord travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Concord?", a: "Popular options include the Concord Post Office (03301), Bow Post Office (03304), Pembroke Post Office (03275), and Concord City Clerk (03301). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Concord?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Bow or Pembroke?", a: "We serve all of central New Hampshire including Bow, Pembroke, Loudon, Hopkinton, Chichester, Epsom, Boscawen, Weare, Goffstown, and Dunbarton. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Concord?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Concord", address: "55 Fort Eddy Rd, Concord, NH 03301", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Concord", address: "131 Loudon Rd, Concord, NH 03301", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Concord", address: "77 Fort Eddy Rd, Concord, NH 03301", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
    { name: "UPS Store — Concord", address: "1 Bismark St, Concord, NH 03301", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Concord", address: "344 Loudon Rd, Concord, NH 03301", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/photo" },
    { name: "Rite Aid — Concord", address: "7 Bow Center Rd, Bow, NH 03304", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/photo" },
    { name: "Postal Annex — Pembroke", address: "6 S Pembroke Rd, Pembroke, NH 03275", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM", website: "https://www.postalannex.com/" },
    { name: "Costco — Concord", address: "71 Interstate Dr, Concord, NH 03301", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/photo" },
  ],
  dmvLocations: [
    { name: "DMV — Concord", address: "23 Hazen Dr, Concord, NH 03301", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and driver's license renewals. Appointment required.", featured: true },
    { name: "DMV — Manchester", address: "23 Hazard Ave, Manchester, NH 03109", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Online appointment booking.", featured: false },
    { name: "DMV — Tilton", address: "11 E Main St, Tilton, NH 03276", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Newport", address: "10 Main St, Newport, NH 03773", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for western New Hampshire residents.", featured: true },
  ],
  airports: [
    { code: "CON", name: "Concord Municipal Airport", distance: "2 miles from downtown Concord", address: "71 Airport Rd, Concord, NH 03301", note: "Regional airport for general aviation. Charter and private flights available.", flightUrl: "https://www.concordairport.org/", flightLabel: "Concord Airport", featured: true },
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "25 miles from Concord", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major commercial airport for Concord travelers. International flights to Canada and Europe. Major domestic hub.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: false },
    { code: "BOS", name: "Boston Logan International Airport", distance: "75 miles from Concord", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-93.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
  ],
};